import { Row } from 'farmhub-ui-core';

import { TitleText } from 'components';

import { Title } from './styles';

interface MenuTitleProps {
  title: string;
}

const MenuTitle = ({ title }: MenuTitleProps): JSX.Element => (
  <Row justifyContent="space-between">
    <Title key={title}>
      <TitleText className="titleText" color="primary">
        {title}
      </TitleText>
    </Title>
  </Row>
);

export default MenuTitle;
